<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="descricao"
    item-value="id"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:selection="item">
      {{ labelSelected(item) }}
    </template>
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-chip
          class="mr-2"
          color="primary"
          label
        >
          {{ item.item.codigo }}
        </v-chip>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.item.descricao }}
          </v-list-item-title>
        </v-list-item-content>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import Vue from 'vue';
import CfopService from '@/api/cfop-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    label: {
      type: String,
      default: 'Cfops',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    labelSelected() {
      return item => `${item.item.codigo} - ${Vue.filter('truncate')(item.item.descricao, 90)}`;
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchItems(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      if (isSelected) {
        return;
      }

      const searchValue = (isSelected || !val) ? '' : val;

      this.loading = true;
      CfopService.getCfopsPage({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `descricao like "%${searchValue.toLowerCase()}%" or codigo like "%${searchValue.toLowerCase()}%" or codigoGrupo like "%${searchValue.toLowerCase()}%" or descricao like "%${searchValue.toLowerCase()}%"`,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
